import axios from 'axios';
import { getApiUrl } from '../../../config';

export const getInvoices = (start, limit, status, opts = {}) => {
    const params = { start, limit };
    if (status) params.status = status;
    if (opts && opts.search) params.search = opts.search;
    if (opts && opts.sortBy) params.sortBy = opts.sortBy;
    if (opts && opts.sortDir) params.sortDir = opts.sortDir;

    return axios.request({
        method: 'GET',
        url: `${getApiUrl()}/billing/invoices`,
        params,
        withCredentials: true,
        crossorigin: true
    });
}

export const getInvoice = (id) => {
    return axios.request({
        method: 'GET',
        url: `${getApiUrl()}/billing/invoices/${id}`,
        withCredentials: true,
        crossorigin: true
    });
}

export const createInvoice = (invoice) => {
    return axios.request({
        method: 'POST',
        url: `${getApiUrl()}/billing/invoices`,
        data: invoice,
        withCredentials: true,
        crossorigin: true
    });
}

export const updateInvoice = (id, invoice) => {
    return axios.request({
        method: 'PUT',
        url: `${getApiUrl()}/billing/invoices/${id}`,
        data: invoice,
        withCredentials: true,
        crossorigin: true
    });
}

export const sendInvoice = (id) => {
    return axios.request({
        method: 'PUT',
        url: `${getApiUrl()}/billing/invoices/${id}/send`,
        withCredentials: true,
        crossorigin: true
    });
}

export const cancelInvoice = (id) => {
    return axios.request({
        method: 'PUT',
        url: `${getApiUrl()}/billing/invoices/${id}/cancel`,
        withCredentials: true,
        crossorigin: true
    });
}

export const updateInvoiceStatus = (id, status) => {
    return axios.request({
        method: 'PUT',
        url: `${getApiUrl()}/billing/invoices/${id}/status`,
        data: { status },
        withCredentials: true,
        crossorigin: true
    });
}

export const createCreditMemo = (id, creditData) => {
    return axios.request({
        method: 'POST',
        url: `${getApiUrl()}/billing/invoices/${id}/credit`,
        data: creditData,
        withCredentials: true,
        crossorigin: true
    });
}

export const exportInvoicesIif = (opts = {}) => {
    const params = {};
    if (opts && opts.ids && opts.ids.length) params.ids = Array.isArray(opts.ids) ? opts.ids.join(',') : opts.ids;
    if (opts && opts.start) params.start = opts.start;
    if (opts && opts.end) params.end = opts.end;

    return axios.request({
        method: 'GET',
        url: `${getApiUrl()}/billing/invoices/export/iif`,
        params,
        responseType: 'blob',
        withCredentials: true,
        crossorigin: true
    });
}

export const generateLastMonthInvoices = (month, dueDate, invoiceDate) => {
    const data = {};
    if (month) data.month = month;
    if (dueDate) data.dueDate = dueDate;
    if (invoiceDate) data.invoiceDate = invoiceDate;

    return axios.request({
        method: 'POST',
        url: `${getApiUrl()}/billing/invoices/generateLastMonth`,
        data,
        withCredentials: true,
        crossorigin: true
    });
}

export const sendInvoiceToGateway = (id) => {
    return axios.request({
        method: 'PUT',
        url: `${getApiUrl()}/billing/invoices/${id}/sendGateway`,
        withCredentials: true,
        crossorigin: true
    });
}

export const deleteInvoice = (id) => {
    return axios.request({
        method: 'DELETE',
        url: `${getApiUrl()}/billing/invoices/${id}`,
        withCredentials: true,
        crossorigin: true
    });
}

export const updateInvoiceLineItems = (id, lineItems) => {
    return axios.request({
        method: 'PUT',
        url: `${getApiUrl()}/billing/invoices/${id}/lineItems`,
        data: { lineItems },
        withCredentials: true,
        crossorigin: true
    });
}

export const getInvoicesByBillingEntities = () => {
    return axios.request({
        method: 'GET',
        url: `${getApiUrl()}/billing/invoices/byBillingEntities`,
        withCredentials: true,
        crossorigin: true
    });
}

export const recordClientPayment = (invoiceId, paymentData) => {
    return axios.request({
        method: 'POST',
        url: `${getApiUrl()}/billing/invoices/${invoiceId}/payment`,
        data: paymentData,
        withCredentials: true,
        crossorigin: true
    });
}

export const getClientsWithRecentInvoices = () => {
    return axios.request({
        method: 'GET',
        url: `${getApiUrl()}/billing/invoices/clients-with-recent-invoices`,
        withCredentials: true,
        crossorigin: true
    });
}

export const getInactiveClients = () => {
    return axios.request({
        method: 'GET',
        url: `${getApiUrl()}/billing/invoices/inactiveClients`,
        withCredentials: true,
        crossorigin: true
    });
}

export const getInvoiceSummary = () => {
    return axios.request({
        method: 'GET',
        url: `${getApiUrl()}/billing/invoices/summary`,
        withCredentials: true,
        crossorigin: true
    });
}

export const getClientBillingOverview = (clientId, start, limit) => {
    return axios.request({
        method: 'GET',
        url: `${getApiUrl()}/billing/invoices/clientOverview/${clientId}`,
        params: { start, limit },
        withCredentials: true,
        crossorigin: true
    });
}

export const sendAllDraftInvoices = (opts = {}) => axios.request({
    method: 'POST',
    url: `${getApiUrl()}/billing/invoices/sendAllDrafts`,
    data: opts && opts.month ? { month: opts.month } : {},
    withCredentials: true,
    crossorigin: true
});

export const getInvoiceOrphans = (invoiceId, opts = {}) => {
    const params = {};
    if (opts && opts.includeAllUnbilled) params.includeAllUnbilled = true;
    if (opts && opts.month) params.month = opts.month;

    return axios.request({
        method: 'GET',
        url: `${getApiUrl()}/billing/invoices/${invoiceId}/orphans`,
        params,
        withCredentials: true,
        crossorigin: true
    });
};

export const addInvoiceOrphans = (invoiceId, body) => axios.request({
    method: 'POST',
    url: `${getApiUrl()}/billing/invoices/${invoiceId}/addOrphans`,
    data: body,
    withCredentials: true,
    crossorigin: true
});

export const getPdfTemplateConfig = () => axios.request({
    method: 'GET',
    url: `${getApiUrl()}/billing/invoices/pdfTemplate/config`,
    withCredentials: true,
    crossorigin: true
});

export const savePdfTemplateConfig = (config) => axios.request({
    method: 'POST',
    url: `${getApiUrl()}/billing/invoices/pdfTemplate/config`,
    data: config,
    withCredentials: true,
    crossorigin: true
});

export const uploadPdfTemplate = (formData) => axios.request({
    method: 'POST',
    url: `${getApiUrl()}/billing/invoices/pdfTemplate/upload`,
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
    withCredentials: true,
    crossorigin: true
});

export const downloadInvoicePdf = (invoiceId) => axios.request({
    method: 'GET',
    url: `${getApiUrl()}/billing/invoices/${invoiceId}/pdf`,
    responseType: 'blob',
    withCredentials: true,
    crossorigin: true
});

export const getIntuitConnectionStatus = () => axios.request({
    method: 'GET',
    url: `${getApiUrl()}/billing/invoices/intuit/connectionStatus`,
    withCredentials: true,
    crossorigin: true
});

export const getIntuitCustomers = () => axios.request({
    method: 'GET',
    url: `${getApiUrl()}/billing/invoices/intuit/customers`,
    withCredentials: true,
    crossorigin: true
});

export const getUnbilledReport = (month) => {
    const params = {};
    if (month) params.month = month;
    return axios.request({
        method: 'GET',
        url: `${getApiUrl()}/billing/invoices/unbilled`,
        params,
        withCredentials: true,
        crossorigin: true
    });
};

export const getInvoiceNumberPreview = (pattern) => axios.request({
    method: 'GET',
    url: `${getApiUrl()}/billing/invoices/number-preview`,
    params: { pattern },
    withCredentials: true,
    crossorigin: true
});

export const getBillingPreview = (clientId, month) => {
    const params = {};
    if (month) params.month = month;
    return axios.request({
        method: 'GET',
        url: `${getApiUrl()}/billing/invoices/preview/${clientId}`,
        params,
        withCredentials: true,
        crossorigin: true
    });
};

export const getInvoicedPeriodForDate = ({ date, projectId, accountId }) => {
    const params = { date };
    if (projectId) params.project = projectId;
    if (accountId) params.account = accountId;
    return axios.request({
        method: 'GET',
        url: `${getApiUrl()}/billing/invoices/coversDate`,
        params,
        withCredentials: true,
        crossorigin: true
    });
};
